import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { normalize, schema } from 'normalizr';
import { loadPayments, exportPayments} from './actions';
import Filter from './PaymentsFilter';
import List from './PaymentsList';
import authUtils from '../../auth/utils';
import { withTranslation } from 'react-i18next';
import SendMessageButton from '../../common/components/message/SendMessageButton';
import {
	sendMessage,
	PARENT_SEND_MESSAGE_REQUEST, PARENT_SEND_MESSAGE_SUCCESS, PARENT_SEND_MESSAGE_FAILURE
} from '../parents/actions';

class Payments extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleListSelectionChange = this.handleListSelectionChange.bind(this);
		this.handleSendMessage = this.handleSendMessage.bind(this);
		this.state = {
			selectedEntities: []
		}
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		filter = {
			...filter,
			isInstalmentPayment: true
		};
		this.props.loadEntities({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	handleFilterSubmit(filter, exportFormat) {
		const { sortKey, sortDirection, pageSize } = this.props.pagination;
		this.setState({ selectedEntities: [] });
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
		if (exportFormat) {
			this.exportData(filter);
		}
	}

	exportData(filter) {
		filter = {
			...filter,
			isInstalmentPayment: true
		};
		this.props.exportEntities(filter);
	}

	handleFilterReset() {
		this.handleFilterSubmit();
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	handleListSelectionChange(newSelectedEntities) {
		this.setState({ selectedEntities: newSelectedEntities });
	}

	handleSendMessage(values, onSuccess) {
		const { sendMessage } = this.props;
		sendMessage({ ...values, parentIds: this.selectedParentIds() }, onSuccess);
	}

	selectedParentIds() {
		return [...new Set(this.state.selectedEntities.map(item => item.parent.id))]
	}

	normalizeData(payments) {
		const parent = new schema.Entity('parents', {}, {
			idAttribute: c => c.id
		});
		const payment = new schema.Entity('payments', { parent: parent }, {
			idAttribute: p => p.id
		});
		const normalizedData = normalize(payments, [payment]);
		return normalizedData;
	}

	renderListActions() {
		const { canSendMessage } = this.props;

		const normalizedData = this.normalizeData(this.state.selectedEntities);
		const parents = normalizedData && normalizedData.entities && normalizedData.entities.parents;

		return <React.Fragment>
			{canSendMessage && <SendMessageButton onSendMessage={this.handleSendMessage} to={parents && Object.values(parents).map(p => ({ name: p.fullname, email: p.email }))}
				block={PARENT_SEND_MESSAGE_REQUEST} unblock={[PARENT_SEND_MESSAGE_SUCCESS, PARENT_SEND_MESSAGE_FAILURE]} />}
		</React.Fragment>
	}

	render() {
		const { isReadonly, paymentStatusTypes, paymentMethods, canSendMessage, paymentCategories, enableManualInstalment } = this.props;
		return (
			<div>
				<Filter onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset} paymentCategories={paymentCategories}
					paymentStatusTypes={paymentStatusTypes} paymentMethods={paymentMethods} enableManualInstalment={enableManualInstalment} loading={this.props.pagination.loading || this.props.export.loading} />
				<List isReadonly={isReadonly} onFetchData={this.handleListEvent} data={this.props.data} {...this.props.pagination}
					selectedEntities={this.state.selectedEntities} onSelectionChange={this.handleListSelectionChange}
					listActions={this.renderListActions()} canSendMessage={canSendMessage}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const {
		pagination,
		exports,
		entities: { payments },
		lookups: { paymentStatusTypes, paymentMethods, paymentCategories },
		auth: { currentUser },
		configuration: { franchisor }
	} = state;

	const paymentsPagination = pagination.payments.all || { ids: [], pageNumber: 1, pageSize: 10 };
	const paymentsExport = exports.payments.all || {};

	return {
		data: paymentsPagination.ids.map(id => payments[id]),
		pagination: paymentsPagination,
		export: paymentsExport,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'PaymentHistory'),
		paymentStatusTypes: paymentStatusTypes,
		paymentMethods: paymentMethods,
		enableManualInstalment: franchisor.enableManualInstalment,
		canSendMessage: franchisor.enableAdHocMessages && authUtils.hasPermission(currentUser, 'SendMessage'),
		paymentCategories
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadPayments,
	exportEntities: exportPayments,
	sendMessage,
	initializeFilter: (data, fields) => initialize('paymentsFilter', data, fields)
})(withTranslation()(Payments));